import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { candidateExplainerData as data } from "../data/candidate-explainer.data";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import styles from "./candidate-explainer.module.scss";
import "./candidate-explainer.scss";

import img1 from "../assets/images/si/issues-1.png";

export function SiSupportIssues() {
  const redirect = useRedirectUrl("/second-interview-support");

  return (
    <div className={`${styles["candidateExplainer"]} candidate-container`}>
      <Helmet>
        <title>Sapia | Candidate Explainer</title>
        <meta http-equiv="refresh" content="0; url=https://sapia.ai/second-interview-support/technical-interviews-troubleshooting/" />
      </Helmet>

      {/* <div className={styles["explainerBanner"]}>
        <ul className={styles["landingBreadcrumbs"]}>
          {data?.header_section?.breadcrums.map((b, i) => {
            switch (i) {
              case 0:
                return (
                  <li className={styles["candidateBtn"]} key={i}>
                    <a href={redirect}>{b.label}</a>
                  </li>
                );
              default:
                return b.link ? (
                  <li key={i}>
                    <Link to={b.link}>{b.label}</Link>
                  </li>
                ) : (
                  <span>{b.label}</span>
                );
            }
          })}
        </ul>

        <div className={styles["tableOfContent"]}>
          <h3>Technical issues and troubleshooting</h3>
          <ul>
            <li>
              <a href="#1">
                I have lost the link to the interview, what do I do?
              </a>
            </li>
            <li>
              <a href="#2">How do I connect my camera and microphone?</a>
            </li>
            <li>
              <a href="#3">
                My camera is working but audio isn’t (or vice versa)
              </a>
            </li>
            <li>
              <a href="#4">My browser isn’t supported</a>
            </li>
            <li>
              <a href="#5">My internet is unstable</a>
            </li>
            <li>
              <a href="#6">What if I close my browser during the interview?</a>
            </li>
            <li>
              <a href="#7">
                I’ve submitted my responses, but I want to re-do them.
              </a>
            </li>
          </ul>
        </div>

        <div className={styles["siQA"]}>
          <div className={styles["siQAItem"]} id="1">
            <h4>I have lost the link to the interview, what do I do?</h4>
            <p>
              You will have received an from notifications@predictivehire.com,
              which contains your unique link to your SecondInterview. All your
              answers will be saved so you can pick up where you left off. If
              you cannot see the email in your inbox, make sure to check your
              spam/junk folder. If you still can’t find the email please contact
              support.
            </p>
          </div>

          <div className={styles["siQAItem"]} id="2">
            <h4>How do I connect my camera and microphone?</h4>
            <p>
              You should see a pop-up that requests access to your microphone
              and camera, click Allow. If you don’t see the message, you can
              check if you have allowed access by going to your browser or
              device’s settings.
            </p>
          </div>

          <div className={styles["siQAItem"]} id="3">
            <h4>My camera is working but audio isn’t (or vice versa)</h4>
            <p>
              Check your browser or device’s settings to make sure you have
              allowed access to both your camera and microphone.
            </p>
            <p>
              You can also test if they’re working in other programs (eg
              Facebook Messenger, Zoom, etc). If not, you may need to further
              troubleshoot your hardware.
            </p>
          </div>

          <div className={styles["siQAItem"]} id="4">
            <h4>My browser isn’t supported</h4>
            <h5>Desktop</h5>
            <p>
              You have clicked the link to your SecondInterview, but a window
              comes up that says ‘Browser unsupported’.
              <br />
              If this happens, make sure you have the latest version of either
              Chrome, Firefox, Safari, or Edge. You can download any of these
              browsers for free from their respective websites, from the App
              Store, or from the Google Play Store.
            </p>

            <p>
              If you are using one of these four supported browsers and the
              ‘browser unsupported’ window continues to show after clicking the
              link; clear your browser history and cache. If you’re not sure how
              to do this, you can use your preferred search engine to find
              instructions for the browser you are using.
            </p>
            <p>
              If you have done the above and it’s still not working, copy the
              link and open it in a private browsing window, e.g. Incognito in
              Chrome. This option will automatically clear all history and
              cookie data and will allow you to continue with your
              SecondInterview.
            </p>
            <h5>iPhone</h5>
            <p>
              Please complete your interview using Safari. We currently do not
              support Chrome or Firefox on iOS.
            </p>
            <h5>Android</h5>
            <p>
              Please complete your interview using Chrome. We currently do not
              support Firefox on Android.
            </p>
          </div>

          <div className={styles["siQAItem"]} id="5">
            <h4>My internet is unstable</h4>
            <p>
              If you review your videos before pressing submit at the end of
              your interview we will check your internet connection. If it’s
              slower than 2mbps you will get a notification that uploading might
              be affected.
            </p>
            <p>
              If you are unable to upload your responses you will see the
              message displayed below:
            </p>
            <img src={img1} alt="" style={{ width: "70%" }} />
          </div>

          <div className={styles["siQAItem"]} id="6">
            <h4>What if I close my browser during the interview?</h4>
            <p>
              We only save your answer once you have pressed the Save button.
              Once you have finished and confirmed that you have saved your
              response, you can close your browser. <br />
              To return, simply go to the email link and restart the interview
              from where you left off. If your browser crashes or is closed
              mid-way through a response you can use the email link to return to
              the last saved response.
            </p>
          </div>

          <div className={styles["siQAItem"]} id="7">
            <h4>I’ve submitted my responses, but I want to re-do them.</h4>
            <p>
              Just like with a face-to-face interview, once you’ve completed and
              submitted your responses you’re no longer able to amend them. We
              suggest reviewing your videos before you click submit to make sure
              you’re happy with your answers.
            </p>
          </div>
        </div>
      </div>

      <div className="interview-support-section explainer-padding">
        <div className="container">
          <div className="text-center">
            <h3 className="blue-title">{data.contact_section.section_title}</h3>
            <button
              type="button"
              className="btn-help"
              style={{ cursor: "pointer" }}
            >
              {data.contact_section.button_label}
            </button>
            <p>
              <a
                href={data.contact_section.privacy_button_link}
                className="black-link"
              >
                {data.contact_section.privacy_button_label}
              </a>
            </p>
            <p>
              <a href="/terms-of-service" className="black-link">
                Read our Terms of Service here {">"}
              </a>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
}
